// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"39fd97c4","999":"363901c4"}[chunkId] + ".chunk.css";
};